module.exports = __webpack_public_path__ + "static/media/four.3f08e748.svg";